import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Cloud, Shield, Share2, Lock } from 'lucide-react';
import Button from '../../common/Button';

const NextcloudSolution = () => {
  const { t } = useTranslatedContent('nextcloud');

  const features = {
    storage: {
      title: t('features.items.0.title'),
      description: t('features.items.0.description')
    },
    security: {
      title: t('features.items.1.title'),
      description: t('features.items.1.description')
    },
    collaboration: {
      title: t('features.items.2.title'),
      description: t('features.items.2.description')
    },
    access: {
      title: t('features.items.3.title'),
      description: t('features.items.3.description')
    }
  };

  return (
    <div className="bg-gradient-to-br from-indigo-900 to-blue-900 rounded-3xl p-8 lg:p-12 text-white">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-semibold">{t('title')}</h3>
        <p className="mt-4 text-indigo-100">{t('subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Cloud className="h-8 w-8 text-indigo-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.storage.title}</h4>
          <p className="text-indigo-100">{features.storage.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Shield className="h-8 w-8 text-indigo-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.security.title}</h4>
          <p className="text-indigo-100">{features.security.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Share2 className="h-8 w-8 text-indigo-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.collaboration.title}</h4>
          <p className="text-indigo-100">{features.collaboration.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Lock className="h-8 w-8 text-indigo-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.access.title}</h4>
          <p className="text-indigo-100">{features.access.description}</p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Button
          variant="secondary"
          className="bg-white text-indigo-900 hover:bg-indigo-50"
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          {t('hero.buttonText')}
        </Button>
      </div>
    </div>
  );
};

export default NextcloudSolution;